// extracted by mini-css-extract-plugin
module.exports = {"searchResultItem":"searchItem_searchResultItem__gkBLK","secondRow":"searchItem_secondRow__FwuZJ","text":"searchItem_text__4_4nF"};